import React from 'react'
import icon from '../assets/icon.png'

import { Link } from 'react-router-dom'

export default function Footer({ className }) {
  return (

    <footer className={`bg-[#F0F0F0] rounded-lg shadow-xl ${className}`}>
      <div className="w-full max-w-screen-xl p-4 mx-auto md:py-6">
        <div className="sm:flex sm:items-center sm:justify-between">
          <Link to={'/'} className="flex items-center mb-4 sm:mb-0">
            <img src={icon} className="h-8 mr-3 select-none" alt="LastCarZone Logo" />
            <span className="self-center text-2xl font-semibold whitespace-nowrap ">Last Car Zone</span>
          </Link>
          <ul className="flex flex-wrap items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 ">
            <li>
              <Link to={''} className="mr-4 hover:underline md:mr-6 ">About</Link>
            </li>
            <li>
              <Link to={''} className="mr-4 hover:underline md:mr-6">Contact</Link>
            </li>
            <li>
              <Link to={'/collection'} className="mr-4 hover:underline md:mr-6 ">Collection</Link>
            </li>
            <li>
              <Link to={''} className="hover:underline">Orders</Link>
            </li>
          </ul>
        </div>


        <hr className="my-3 border-gray-200 sm:mx-auto lg:my-3" />
        <span className="block text-sm text-gray-500 sm:text-center ">© 2023 <Link to={'/'} className="hover:underline">LastCarZone</Link>. All Rights Reserved.</span>
      </div>
    </footer>






  )
}
